import React, { FC } from 'react';
import { Control, FieldErrors, UseFormRegister, useWatch } from 'react-hook-form';

import { CurrencyInput } from '@eika/currency-input';

import { BilWeb, DrivstoffWeb } from '../../generated-types';
import { getYear } from '../../infra/date';
import { useTranslation } from '../../translations';
import { BilFormData } from './biler';

interface Props {
    kjoeretoey: BilWeb;
    index: number;
    register: UseFormRegister<BilFormData>;
    control: Control<BilFormData>;
    errors: FieldErrors<BilFormData>;
}

const Kjoeretoey: FC<Props> = ({ kjoeretoey, index, register, control, errors }) => {
    const { biler, validationMessage } = useTranslation();
    const value = useWatch({ name: 'bil', control });

    const drivstoffTekst = (drivstoff: DrivstoffWeb | null) => {
        const typer = biler.drivstoffTyper;
        switch (drivstoff) {
            case DrivstoffWeb.BENSIN:
                return typer.bensin;
            case DrivstoffWeb.DIESEL:
                return typer.bensin;
            case DrivstoffWeb.ELBIL:
                return typer.elektrisk;
            case DrivstoffWeb.HYBRID_BENSIN:
                return typer.hybridBensin;
            case DrivstoffWeb.HYBRID_DIESEL:
                return typer.hybridDiesel;
            case DrivstoffWeb.PARAFIN:
                return typer.parafin;
            case DrivstoffWeb.GASS:
                return typer.gass;
            case DrivstoffWeb.HYDROGEN:
                return typer.hydrogen;
            case DrivstoffWeb.ANNET:
                return typer.annet;
            case DrivstoffWeb.BIOBENSIN:
                return typer.biobensin;
            case DrivstoffWeb.BIODIESEL:
                return typer.biodiesel;
            case DrivstoffWeb.LPG:
                return typer.lpg;
            case DrivstoffWeb.CNG:
                return typer.cng;
            case DrivstoffWeb.METANOL:
                return typer.metanol;
            case DrivstoffWeb.ETANOL:
                return typer.etanol;
            case DrivstoffWeb.KOMPRIMERT_LUFT:
                return typer.komprimertLuft;
            case DrivstoffWeb.LNG:
                return typer.lng;
            case DrivstoffWeb.CNG_LNG:
                return typer.cngLng;
            default:
                return '';
        }
    };

    return (
        <div key={kjoeretoey.merke} className="form-box-seagreen row-gap margin-bottom-small">
            <span className="title">
                {kjoeretoey.merke || ''} {kjoeretoey.modell || ''} {getYear(kjoeretoey.registrertFoersteGangNorge)}{' '}
            </span>
            <span>
                <div>
                    {kjoeretoey.erLeasing ? biler.leasingtaker : biler.eier}: {kjoeretoey.eier?.navn}
                </div>
                <div>
                    {biler.registreringsnummer}: {kjoeretoey.registreringsnummer}
                </div>
                <div>
                    {biler.drivstoff}: {drivstoffTekst(kjoeretoey.drivstoff)}
                </div>
            </span>
            {(kjoeretoey.erLeasing || kjoeretoey.leasingUtgift > 0) && (
                <CurrencyInput
                    className="max-width-200"
                    placeholder=""
                    type="tel"
                    label={biler.labelLeaset}
                    value={value?.[index]?.leasingUtgift ? Number(value?.[index]?.leasingUtgift) : undefined}
                    error={errors.bil?.[index]?.leasingUtgift?.message}
                    {...register(`bil.${index}.leasingUtgift` as const, {
                        required: `${validationMessage.requiredValue}`,
                    })}
                />
            )}
        </div>
    );
};

export default Kjoeretoey;
